import { ref } from 'vue'

const user = ref(null)

export default () => {

    const checkAuth = async () => {
        const user = localStorage.getItem('user')
        if(user) return true        
    }


    return {
        user,
        checkAuth
    }
}